import { Injectable } from '@angular/core';
import { IAppCredentials, IAppSettings } from '@takectrl-multiapp/svcs-share-config';
import { APIHttpService } from './api-http.service';
import { Observable, of } from 'rxjs';
import { ICtrlResponse } from '../interfaces/api.interface';
import { ApiCacheService } from './api-cache.service';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class APISettingsService {
  private readonly CACHE_KEYS = {
    APP_SETTINGS: 'app_settings',
    APP_CREDENTIALS: 'app_credentials',
  };

  constructor(private readonly ctrlApiHttpService: APIHttpService, private readonly cacheService: ApiCacheService) {}

  getAppSettings(): Observable<ICtrlResponse<IAppSettings>> {
    const cached = this.cacheService.get(this.CACHE_KEYS.APP_SETTINGS);
    if (cached) {
      return of(cached);
    }

    return this.ctrlApiHttpService.get(`/app-settings/`).pipe(tap((response) => this.cacheService.set(this.CACHE_KEYS.APP_SETTINGS, response)));
  }

  getAppCredentials(): Observable<ICtrlResponse<IAppCredentials>> {
    const cached = this.cacheService.get(this.CACHE_KEYS.APP_CREDENTIALS);
    if (cached) {
      return of(cached);
    }

    return this.ctrlApiHttpService.get(`/app-credentials/`).pipe(tap((response) => this.cacheService.set(this.CACHE_KEYS.APP_CREDENTIALS, response)));
  }
}
